import { CreditCard, Building2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import type { CustomerPaymentMethod } from '@/hooks/useCustomerPaymentMethods';

interface PaymentMethodDisplayProps {
  paymentMethod: CustomerPaymentMethod;
  showDefault?: boolean;
}

export function PaymentMethodDisplay({ paymentMethod, showDefault = false }: PaymentMethodDisplayProps) {
  const formatPaymentMethod = () => {
    if (paymentMethod.payment_method_type === 'card') {
      return `${paymentMethod.card_brand?.toUpperCase() || 'Card'} ••••${paymentMethod.payment_method_last4}`;
    } else if (paymentMethod.payment_method_type === 'us_bank_account') {
      return `${paymentMethod.bank_name || 'Bank Account'} ••••${paymentMethod.payment_method_last4}`;
    }
    return 'Payment Method';
  };

  const icon = paymentMethod.payment_method_type === 'card' ? (
    <CreditCard className="h-5 w-5" />
  ) : (
    <Building2 className="h-5 w-5" />
  );

  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-2 text-foreground">
        {icon}
        <span className="font-medium">{formatPaymentMethod()}</span>
      </div>
      {paymentMethod.nickname && (
        <span className="text-sm text-muted-foreground">({paymentMethod.nickname})</span>
      )}
      {showDefault && paymentMethod.is_default && (
        <Badge variant="secondary" className="text-xs">Default</Badge>
      )}
    </div>
  );
}
